import { httpClient } from './httpClient'

export interface UploadedFile {
  id: string
  url: string
}

export interface UploadFileConfig {
  /** API path the file is POSTed to as `multipart/form-data` (single `file` field). Defaults to `/files/single`. */
  endpoint?: string
  /** Field in the upload response holding the stored file id. Defaults to `file_id`. */
  responseIdField?: string
  /** Field in the upload response holding the file's public URL. Defaults to `url`. */
  responseUrlField?: string
}

const DEFAULT_ENDPOINT = '/files/single'
const DEFAULT_ID_FIELD = 'file_id'
const DEFAULT_URL_FIELD = 'url'

/**
 * Uploads a single file and returns the id/url the source app's `uploadFile`
 * query gets back (`{file_id, url, ...}`), mirroring its `POST files/single`
 * multipart contract (see retool-exports/branches, /categories, /doctor-profiles).
 */
export async function uploadFile(file: File, config: UploadFileConfig = {}): Promise<UploadedFile> {
  const endpoint = config.endpoint ?? DEFAULT_ENDPOINT
  const idField = config.responseIdField ?? DEFAULT_ID_FIELD
  const urlField = config.responseUrlField ?? DEFAULT_URL_FIELD

  const body = new FormData()
  body.append('file', file)

  const raw = await httpClient<Record<string, unknown>>(endpoint, { method: 'POST', body })
  return { id: raw[idField] as string, url: raw[urlField] as string }
}
